import React from 'react';

interface ConfirmationModalProps {
    open: boolean;
    title: string;
    description?: string;
    onConfirm: () => void;
    onCancel: () => void;
}

const ConfirmationModal: React.FC<ConfirmationModalProps> = ({
    open,
    title,
    description,
    onConfirm,
    onCancel,
}) => {
    if (!open) return null;
    return (
        <div className="confirmation-modal-overlay" style={{
            position: 'fixed',
            inset: 0,
            background: 'rgba(0,0,0,0.25)',
            zIndex: 5100,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
        }}>
            <div className="confirmation-modal" style={{
                background: 'var(--surface-bg-color)',
                borderRadius: 8,
                boxShadow: '0 2px 16px rgba(0,0,0,0.18)',
                padding: 24,
                minWidth: 280,
                maxWidth: 360,
                textAlign: 'center',
            }}>
                <h3 style={{ marginTop: 0 }}>{title}</h3>
                {description && <p style={{ color: '#555' }}>{description}</p>}
                <div style={{ display: 'flex', justifyContent: 'center', gap: 16, marginTop: 24 }}>
                    <button type="button" onClick={onConfirm} className='button'>
                        Aceptar
                    </button>
                    <button type="button" onClick={onCancel} className="button button-secondary">
                        Cancelar
                    </button>
                </div>
            </div>
        </div>
    );
};

export default ConfirmationModal;
